import { quickSearchAutosuggestReducerKey } from './QuickSearchAutosuggestConstants';

export function quickSearchAutosuggestComponent(state) {
  return state.get(quickSearchAutosuggestReducerKey);
}

export function inputValue(state) {
  return quickSearchAutosuggestComponent(state)
    .get('inputValue');
}

export function isLoading(state) {
  return quickSearchAutosuggestComponent(state)
    .get('isLoading');
}

export function selectedMap(state) {
  return quickSearchAutosuggestComponent(state)
    .get('selectedMap');
}
